export default __webpack_public_path__ + "static/media/sound-header.2637c6ef.jpg";